// extracted by mini-css-extract-plugin
export var leftAlign = "_11-2";
export var popper = "_11-0";
export var subtitle = "_11-1";